import React, {Component} from "react";
import {IonBadge, IonChip, IonItem, IonLabel} from "@ionic/react";
import {RouteComponentProps} from "react-router";
import StartListItem from "../../domain/StartListItem";
import DateUtils from "../../utils/Date.utils";
import StringUtils from "../../utils/String.utils";

type Props = RouteComponentProps<{ contestId: string, seriesId: string }> & {
  item: StartListItem;
};

type State = {}

export default class StartListItemComponent extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    const item: StartListItem = this.props.item;
    let hour = null;
    if (item.startHour) {
      hour = <IonChip slot="end">{StringUtils.pad(item.startHour,2)}:{StringUtils.pad(item.startMinutes,2)}</IonChip>;
    }
    return (
      <IonItem class={"start-list-item"}>
        <IonBadge class="start-number" slot="start">
          <h2>{item.startNumber}</h2>
        </IonBadge>
        <IonLabel class="label">
          <p className="label-content"><small>({item.headNumber})</small> {item.rider}</p>
          <p className="label-content">{item.horse}</p>
          <p className="label-content">{item.clubName}</p>
        </IonLabel>
        {hour}
      </IonItem>
    );
  }

}
